import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createQuery } from "../../apis/firestoreDatabase";
import { upload } from "../../apis/firebasecloud";
import { auth } from "../Firebase/Firebase";
import axios from "axios";

import AgencyInfo from "./AgencyInfo";
import Loader from "../loader";
import PaymentInfo from "./PaymentInfo";
import "../../styles/VerificationForm.css";

function Form() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [checkboxStates, setCheckboxStates] = useState([]);
  const [formData, setFormData] = useState({
    email: "",
    agencyName: "",
    agencyEmail: "",
    Designation: "",
    agencyNo: "",
    candidateName: "",
    universityName: "",
    progamName: "",
    prn: "",
    graduationDate: "",
    Documents: "",
    queryDate: "",
    NEFT: "",
    paymentSS: "",
    verificationDocument: "",
    status: "",
    statusDate: ""
  });

  const arePage1FieldsFilled = (formData.email!= "") && (formData.agencyEmail != "") && (formData.agencyName != "") && 
                               (formData.Designation!= "") && (formData.agencyNo != "") && (formData.candidateName != "") && 
                               (formData.universityName!= "") && (formData.progamName != "") && (formData.prn != "") && 
                               (formData.graduationDate!= "") && (formData.Documents != "")  
                        

  const arePage2FieldsFilled = (formData.queryDate!= "")

  const [stateLoader, setStateLoader] = useState("none");

  const PageDisplay = () => {
    if (page === 0) {
      return <AgencyInfo
        formData={formData}
        setFormData={setFormData}
        checkboxStates={checkboxStates}
        setCheckboxStates={setCheckboxStates}
      />;
    } else {
      return <PaymentInfo formData={formData} setFormData={setFormData} />;
    }
  };

  return (
    <>
      <div className="form">
        <Loader setDisplay={stateLoader} />
        <div className="progressbar-container">
          <div className="progressbar-title">
            <p>Form</p>
            <p>Payment Details</p>
          </div>
          <div className="progressbar"> {/*Progress Bar to show which page we are on*/}
            <div
              className="progress-form"
              onClick={() => {
                setPage(0);
                document.querySelector(".pageChange-btn1").focus();
                document.querySelector(".form-submit-btn").style.display =
                  "none";
              }}
              style={{
                backgroundColor:
                  page === 0 ? "#E77455" : page === 1 ? "#E8EDFF" : "#E77455",
              }}
            ></div>

            <div
              className="progress-payment"
              onClick={() => {
                setPage(1);
                document.querySelector(".pageChange-btn2").focus();
                document
                  .querySelector(".pageChange-btn1")
                  .classList.remove("focus");
                document.querySelector(".form-submit-btn").style.display =
                  "block";
              }}
              style={{
                backgroundColor:
                  page === 0 ? "#E8EDFF" : page === 1 ? "#E77455" : "#E77455",
              }}
            ></div>
          </div>
        </div>
        <div className="form-container">
          <div className="form-body">{PageDisplay()}</div>
          <button //button to submit the formdata as query based on useremail
            className="form-submit-btn"
            style={{ display: page === 0 ? "none" : "block" }}
            onClick={async () => {
              console.log(formData.paymentSS)
              console.log(formData.verificationDocument)
              try {            
               if( !arePage2FieldsFilled) 
                  alert("Please Fill all the details properly");
               else{            
                const Id = await createQuery(formData, auth.currentUser.email); 
                setStateLoader("block");
                await upload(auth.currentUser.email, Id);

                // Send an email to the user acknowledging the submission of the form
                const resp = await axios.post("https://document-verification.rushour0.repl.co/acknowledgeFormSubmission", {
                  to_email: auth.currentUser.email,
                  to_name: formData.candidateName,
                })
                console.log(resp.data);
                setStateLoader("none");
                navigate("/userDashboard");
              };
            } catch (err) {

                console.log("new Error =>" + err);
                alert("Please Fill all the details properly");
              }
            }}
          >
            Submit
          </button>
          <div className="pageChange">
            <button
              className={`pageChange-btn1 ${page === 0 ? 'focus' : ''}`}
              onClick={() => { setPage(0); }}
            >
              1
            </button>
            <button
              className={`pageChange-btn2 ${page === 1 ? 'focus' : ''}`}
              onClick={() => { !arePage1FieldsFilled ? alert("Please Fill all the details properly") :  setPage(1);   }}             
            >
              2
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Form;
